import each from 'lodash/each';

import config from 'config';
import logger from '../../utils/logger';

class Snapchat {
  constructor() {
    if (window.snaptr) {
      snaptr('init', config.SNAPCHAT);
    }
  }

  _track(type, payload) {
    if (payload) {
      snaptr('track', type, payload);

      logger.log(`VS Snapchat ${type} event with payload:`);

      logger.log(payload);
    } else {
      snaptr('track', type);

      logger.log(`VS Snapchat ${type} event.`);
    }
  }

  viewPage() {
    logger.groupCollapsed('VS Snapchat');

    this._track('PAGE_VIEW');

    logger.groupEnd();
  }

  viewSales({ state }) {
    logger.groupCollapsed('VS Snapchat');

    if (logger.checkRetargeting(state.campaign.tracking.global.disable_vs_retargeting)) {
      let payload = {
        item_ids: [state.campaign.analytics_cid],
      };

      if (state.campaign.category) {
        payload.item_category = state.campaign.category;
      }

      this._track('PAGE_VIEW');
      this._track('VIEW_CONTENT', payload);
    } else {
      logger.log('VS Snapchat disabled.');
    }

    logger.groupEnd();
  }

  viewThankYou({ state }) {
    logger.groupCollapsed('VS Snapchat');

    let payload = {
      currency: 'USD',
      price: 0,
      transaction_id: state.order.order_lookup_number,
    };

    each(state.order.orders, order => {
      if (logger.checkRetargeting(state.order.tracking[order.analytics_cid].global.disable_vs_retargeting)) {
        each(order.products, item => {
          payload.price += item.discounted_price;
        });
      }
    });

    payload.price = Math.round(payload.price * 100) / 100;

    if (payload.price) {
      this._track('PAGE_VIEW');
      this._track('PURCHASE', payload);
    } else {
      logger.log('VS Snapchat disabled.');
    }

    logger.groupEnd();
  }

  addToCart({ state }) {
    logger.groupCollapsed('VS Snapchat');

    if (logger.checkRetargeting(state.campaign.tracking.global.disable_vs_retargeting)) {
      this._track('ADD_CART', {
        number_items: state.quantity,
      });
    } else {
      logger.log('VS Snapchat disabled.')
    }

    logger.groupEnd();
  }

  initiateCheckout({ state }) {
    logger.groupCollapsed('VS Snapchat');

    let retargetingDisabled = true;

    each(state.cart.items, item => {
      if (logger.checkRetargeting(state.cart.tracking[item.analytics_cid].global.disable_vs_retargeting)) {
        retargetingDisabled = false;
      }
    });

    if (!retargetingDisabled) {
      this._track('START_CHECKOUT');
    } else {
      logger.log('VS Snapchat disabled.');
    }

    logger.groupEnd();
  }

  register() {
    logger.groupCollapsed('VS Snapchat');

    this._track('SIGN_UP');

    logger.groupEnd();
  }

  login() {
    logger.groupCollapsed('VS Snapchat');

    this._track('LOGIN');

    logger.groupEnd();
  }

  search({ rootState }) {
    logger.groupCollapsed('VS Snapchat');

    this._track('SEARCH', {
      search_string: rootState.marketplace.search,
    });

    logger.groupEnd();
  }
};

export default new Snapchat();